import React, { Component } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import moment from 'moment-timezone';
import { Grid, Button, MenuItem, Paper, Input, Select, Dialog, DialogContent } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import environment from '../../environment';

const getGameByTypeQuery = graphql`
  query GameDetailsGetGameByTypeQuery(
    $game_type_id: ID!
    $name: String!
  ){
    findGameByTypeName(name: $name, game_type_id: $game_type_id) {
      data {
        _id
        name
        created_at
      }
    }
  }
`;

const getGameByIdQuery = graphql`
  query GameDetailsGetGameByIdQuery(
    $id: ID!
  ){
    findGameById(id: $id) {
      data {
        _id
        name
      }
    }
  }
`;

class GameDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
          searchVal: "",
          selectedType: "0",
          selectedGame: {},
          open: false,
          gameNum: "",
          totalGame: 1,
        }
        this.selectType = this.selectType.bind(this);
        this.selectGame = this.selectGame.bind(this);
        this.search = this.search.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.removeGame = this.removeGame.bind(this);
    }

    componentDidMount(){
      if(this.props.state.values["game2_id"]) this.setState({totalGame: 2});
      if(this.props.state.values["game3_id"]) this.setState({totalGame: 3});
    }

    selectType(e){
      this.setState({selectedType: e.target.value});
    }

    selectGame(game_id, game_name){
      const gameNum = this.state.gameNum;
      this.setState(prev => ({
        selectedGame: {
          ...prev.selectedGame,
          [gameNum]: game_id,
        },
      }))
      const event = {
        target: {
          name: gameNum,
          value: game_id,
        }
      };
      this.props.handleChange(event);
      this.setState({searchVal: "", selectedType: "0"});
      this.handleClose();
    }

    search(e){
      this.setState({searchVal: e.target.value});
    }

    handleOpen(name){
      this.setState({open: true, gameNum: name});
    }

    handleClose(){
      this.setState({open: false});
    }
    
    removeGame(i){
      let event;
      let event2;
      let total_game = this.state.totalGame;
      const game3id = this.props.state.values.game3_id;
      if(i == 1){
        this.setState({totalGame: total_game - 1});
        if(total_game - 1 == 2){
          // If there was game 3, change it to become game 2
          event = {
            target: {
              name: "game2_id",
              value: game3id,
            }
          }
          if(this.state.selectedGame["game3_id"]) delete this.state.selectedGame["game3_id"]
        } else {
          event = {
            target: {
              name: "game2_id",
              value: null,
            }
          };
          if(this.state.selectedGame["game2_id"]) delete this.state.selectedGame["game2_id"]
        }
      } else {
        this.setState({totalGame: total_game - 1});
        event = {
          target: {
            name: "game3_id",
            value: null,
          }
        };
        if(this.state.selectedGame["game3_id"]) delete this.state.selectedGame["game3_id"]
      }
      this.props.handleChange(event);
    }

    render(){
        const {
            classes,
            handlePrevious,
            handleNext,
            state,
            gameTypes,
        } = this.props;
        const { values, game_arr } = state;
        const { selectedType, searchVal, selectedGame, gameNum, open, totalGame } = this.state;
        return (
            <>
                <div className={classes.fieldsContainer}>
                <Grid container spacing={4}>
                  {game_arr.slice(0,totalGame).map((obj, i) => {
                    let game_id = selectedGame[obj.name];
                    if(values && values[obj.name]) game_id = values[obj.name];
                    return (
                      <Grid item md={6} xs={12} key={i}>
                        <label className={classes.gameLabel}>
                          {obj.label}
                          {obj.required ? (
                            <span className={classes.requiredAsterisk}>
                              {' '}
                              *
                            </span>
                          ) : (
                            ''
                          )}
                        </label>
                        {
                          i != 0 ?
                          <span className={classes.removeButton} onClick={() => this.removeGame(i)}>
                            remove
                          </span>
                          : <></>
                        }
                        {
                          game_id ?
                          <QueryRenderer
                          environment={environment}
                          query={getGameByIdQuery}
                          variables={{
                            id: game_id,
                          }}
                          render={({error, props}) => {
                            let selected = "";
                            if(props && props.findGameById.data){
                              selected = props.findGameById.data.name;
                            }
                            return(
                              <Select
                              fullWidth
                              value={selected}
                              onClick={() => this.handleOpen(obj.name)}
                              inputProps={{readOnly: true}}
                              >
                                <MenuItem value={selected}>
                                  {selected}
                                </MenuItem>
                              </Select>
                            )
                          }}
                          />
                          :
                          <Select
                          fullWidth
                          value=""
                          onClick={() => this.handleOpen(obj.name)}
                          inputProps={{readOnly: true}}
                          >
                            <MenuItem value=""></MenuItem>
                          </Select>
                        }
                      </Grid>
                    )
                  })
                  }
                  {
                    totalGame < 3 ?
                    <Grid container spacing={4}>
                      <Grid item md={12} xs={12}>
                        <Button variant="text" className={classes.addGameButton} onClick={() => this.setState(prev => ({ totalGame: prev.totalGame + 1 }))}>
                          + Add Game
                        </Button>
                      </Grid>
                    </Grid>
                    : <></>
                  }
                  </Grid>
                </div>
                <Grid container className={classes.buttonContainer} spacing={4}>
                  <Button
                    className={classes.previousButton}
                    onClick={() => handlePrevious('game_details')}
                    variant="contained"
                    color="default"
                  >
                    Previous
                  </Button>
                  <Button
                    className={classes.nextButton}
                    onClick={() => handleNext('game_details')}
                    variant="contained"
                    color="primary"
                  >
                    Next
                  </Button>
                </Grid>
                <Dialog open={open} onClose={this.handleClose} classes={{paper: classes.dialogPaper}}>
                  <DialogContent>
                    <Paper elevation={0} style={{display: 'flex'}}>
                      <Select
                        displayEmpty
                        value={selectedType}
                        onChange={(e) => this.selectType(e)}
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={"0"}>All</MenuItem>
                        {
                          gameTypes.map(type => (
                            <MenuItem value={type._id} key={type._id}>
                              {type.name}
                            </MenuItem>
                          ))
                        }
                      </Select>
                      <Input
                        fullWidth
                        placeholder="Search here"
                        value={this.state.searchVal}
                        onChange={(e) => this.search(e)}
                      />
                    </Paper>
                    <Paper elevation={0} className={classes.gamelist}>
                    <QueryRenderer
                      environment={environment}
                      query={getGameByTypeQuery}
                      variables={{
                        game_type_id: selectedType,
                        name: searchVal,
                      }}
                      render={({error, props}) => {
                        if(props && props.findGameByTypeName.data){
                          const data = props.findGameByTypeName.data;
                          return (
                            data.map((game, i) => {
                              const isGame2 = gameNum == "game2_id";
                              const game1_id = selectedGame["game1_id"];
                              const dup = isGame2 && (game1_id) && (game1_id == game._id);
                              if (!dup)
                                return (
                                  <MenuItem
                                    divider
                                    onClick={() => this.selectGame(game._id, game.name)}
                                    style={{paddingLeft: 0}}
                                    key={i}
                                  >
                                    {game.name}
                                    <span className={classes.dateFont}>
                                      {moment(game.created_at).format("M/D/YYYY")}
                                    </span>
                                  </MenuItem>
                                )
                          })
                          )
                        }
                      }}
                    />
                    </Paper>
                  </DialogContent>
                </Dialog>
              </>
        )
    }
}

export default withStyles(useStyles)(GameDetails)